<template>
  <div>
    {{ configs.search.name }}
    <v-data-table
        ref="membersTable"
        hide-default-footer
        show-expand
        class="elevation-1"
        :sort-by.sync="configs.sort.by"
        :sort-desc.sync="configs.sort.desc"
        :headers="headers"
        :items="items"
        :loading="configs.loading"
        :options.sync="options"
        :page.sync="configs.page"
        :server-items-length="totalItems"
        :single-expand="true"
        @page-count="configs.pageCount = $event"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
              :label="$t('label.search')"
              outlined
              clearable
              dense
              prepend-inner-icon="mdi-filter"
              class="pt-5"
              v-model="configs.search.name"
          />

          <v-divider class="mx-4" inset vertical/>

          <DatePickerInput
              readonly
              outlined
              dense
              label="anniversary"
              type="month"
              v-model="configs.search.birthday"
              clearable
          />

          <v-divider class="mx-4" inset vertical/>

          <v-btn text @click="exportPdf" class="mb-2">
            PDF
            <v-icon dark v-text="'mdi-file-pdf'"/>
          </v-btn>

          <v-spacer/>
          <v-dialog v-model="configs.dialog" max-width="75%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
              >{{ $t('label.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar color="white" flat>
                <v-btn icon light disabled>
                  <v-icon color="grey darken-2">mdi-account</v-icon>
                </v-btn>
                <v-toolbar-title class="grey--text text--darken-4">{{ formTitle }}</v-toolbar-title>
                <v-spacer/>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-sheet v-for="errors in configs.form.errors">
                    <v-alert type="error" v-for="error in errors" dismissible close-icon="mdi-close-thick">
                      {{ error }}
                    </v-alert>
                  </v-sheet>
                  <ValidationObserver ref="FormMember" v-slot="{ validate, reset }">
                    <v-form ref="FormMember" v-model="configs.form.valid">
                      <v-row>
                        <v-col cols="12" sm="6" md="2">
                          <v-img
                              :src="configs.dataImage || editedItem.image + '' || ''"
                              lazy-src="https://via.placeholder.com/232x310?text=Foto3x4"
                              aspect-ratio="1"
                              class="grey lighten-2"
                              max-width="232"
                              max-height="310"
                              min-height="310"
                              elevation="12"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <TextInput
                              required
                              label="name"
                              prepend-icon="mdi-account"
                              rules="required|max:100"
                              v-model="editedItem.name"
                              :counter="100"
                              :errors="configs.form.errors.name"
                          />
                          <ComboboxInput
                              hide-no-data
                              hide-selected
                              v-for="relation in configs.relations"
                              v-model="editedItem[relation.id]"
                              :required="relation.required && !!editedItem[relation.required]"
                              :rules="{'required': relation.required && !!editedItem[relation.required]}"
                              :model="editedItem[relation.model_id]"
                              :items="members"
                              :errors="configs.form.errors[relation.id]"
                              :label="relation.label"
                              :prepend-icon="relation.icon"
                              @model="data => editedItem[relation.model_id] = data"
                              @change="data => {relation.required_by ? editedItem[relation.required_by] = !!data : data}"
                          />
                        </v-col>

                        <v-col cols="12" sm="4" md="4">
                          <FileInput
                              show-size
                              accept="image/*"
                              label="image"
                              prepend-icon="mdi-camera"
                              ref="image"
                              rules="size:2048"
                              v-model="configs.image"
                              :counter="configs.image != null"
                              :errors="configs.form.errors.image"
                              :loading="configs.progress"
                              @change="onFileChange"
                          />
                          <DatePickerInput
                              label="birthday"
                              rules="required"
                              v-model="editedItem.birthday"
                              :errors="configs.form.errors.birthday"
                          />

                          <v-row class="pl-1 pt-4">
                            <SwitchInput
                                v-model="editedItem.sex"
                                append-label="sexes"
                                label="sex"
                                rules="required"
                                class="mx-2 gender-switch"
                                :errors="configs.form.errors.sex"
                            />
                            <SwitchInput
                                v-model="editedItem.baptized"
                                label="baptized"
                                class="mx-2"
                                :errors="configs.form.errors.baptized"
                            />
                            <SwitchInput
                                v-model="editedItem.married"
                                label="married"
                                :errors="configs.form.errors.married"
                            />
                          </v-row>
                          <v-row>
                            <v-col cols="6" class="pt-1 pb-0">
                              <DatePickerInput
                                  label="wedding_date"
                                  v-model="editedItem.wedding_date"
                                  :rules="editedItem.married ? 'required' : ''"
                                  :require="editedItem.married"
                                  :disabled="!editedItem.married"
                                  :errors="configs.form.errors.wedding_date"
                              />
                            </v-col>
                            <v-col cols="6" class="pt-3 pb-0">
                              <v-select
                                  v-model="editedItem.blood_type"
                                  :items="bloodTypes"
                                  :label="$tc('label.blood_type', 1)"
                              />
                            </v-col>


                          </v-row>

                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <TextInput
                              required
                              label="address"
                              prepend-icon="mdi-map-marker"
                              rules="required|max:150"
                              v-model="editedItem.address"
                              :errors="configs.form.errors.address"
                          />
                          <TextInput
                              required
                              label="email"
                              prepend-icon="mdi-at"
                              rules="required|email"
                              v-model="editedItem.email"
                              :errors="configs.form.errors.email"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <TextInput
                              required
                              label="city"
                              prepend-icon="mdi-city"
                              rules="required|max:50"
                              v-model="editedItem.city"
                              :errors="configs.form.errors.city"
                          />
                          <TextInput
                              label="mobile"
                              prepend-icon="mdi-cellphone-android"
                              rules="max:50"
                              v-model="editedItem.mobile"
                              v-mask="configs.masks.mobile"
                              :errors="configs.form.errors.mobile"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <TextInput
                              label="cep"
                              prepend-icon="mdi-postage-stamp"
                              rules="max:10"
                              v-model="editedItem.cep"
                              v-mask="configs.masks.cep"
                              :errors="configs.form.errors.cep"
                          />
                          <TextInput
                              label="phone"
                              prepend-icon="mdi-phone-classic"
                              rules="max:50"
                              v-model="editedItem.phone"
                              v-mask="configs.masks.phone"
                              :errors="configs.form.errors.phone"
                          />
                        </v-col>

                        <v-subheader>{{ $tc('label.department', 2) }}</v-subheader>
                        <v-col cols="12" sm="12" md="12">
                          <v-row>
                            <v-col cols="6" sm="6" md="6">
                              <v-select
                                  v-model="configs.department"
                                  :items="departments"
                                  :label="$tc('label.department', 1)"
                              />
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                              <v-select
                                  v-model="configs.role"
                                  :items="roles"
                                  :label="$tc('label.role', 1)"
                              >
                                <template v-slot:append-outer>
                                  <v-btn icon color="green" @click="attachRole">
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>

                          <v-list subheader v-if="editedItem.departments.length">
                            <v-subheader class="float-none row">{{ $tc('label.role', 2) }}</v-subheader>
                            <v-row justify="start">
                              <v-list-item
                                  v-for="(department, index) in editedItem.departments"
                                  class="blue lighten-5 mr-1 mb-1 col"
                              >
                                <v-list-item-icon>
                                  <v-icon color="blue lighten-1">mdi-badge-account-outline</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                  <v-list-item-title v-text="departments.find(item => item.value === department.id).text"
                                                     class="blue-grey--text"></v-list-item-title>
                                  <v-list-item-subtitle v-text="department.role"
                                                        class="blue-grey--text text--lighten-1"></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-btn icon color="red lighten-1" @click="removeRole(index)">
                                    <v-icon>mdi-close-thick</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </v-row>
                          </v-list>

                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">{{ $t('label.cancel') }}</v-btn>
                <v-btn color="blue darken-1" text @click="save">{{ $t('label.save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.image="{ item }">
        <v-avatar size="32">
          <v-img
              v-if="item.image"
              :src="item.image"
              alt="item.name"
          />
          <v-icon v-else large>
            mdi-account-circle
          </v-icon>
        </v-avatar>
      </template>

      <template v-slot:item.sex="{ item }">
        <v-btn :color="(item.sex ? 'blue' : 'red ') + ' lighten-2'" x-small icon>
          <v-icon>{{ item.sex ? 'mdi-gender-male' : 'mdi-gender-female' }}</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.birthday="{ item }">
        {{ (new Date(item.birthday).toLocaleDateString('pt-BR', {timeZone: 'UTC'})) }}
      </template>

      <template v-slot:item.baptized="{ item }">
        <v-simple-checkbox v-model="item.baptized" disabled></v-simple-checkbox>
      </template>

      <template v-slot:item.married="{ item }">
        <v-simple-checkbox v-model="item.married" disabled></v-simple-checkbox>
      </template>

      <template v-slot:item.updated_at="{ item }">
        {{ (new Date(item.updated_at).toLocaleDateString('pt-BR', {timeZone: 'UTC'})) }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th>{{ $t('label.address') }}</th>
                <th>{{ $t('label.city') }}</th>
                <th>{{ $t('label.cep') }}</th>
                <th>{{ $t('label.phone') }}</th>
                <th>{{ $t('label.mobile') }}</th>
                <th>{{ $t('label.father') }}</th>
                <th>{{ $t('label.mother') }}</th>
                <th>{{ $t('label.partner') }}</th>
                <th>{{ $t('label.wedding_date') }}</th>
                <th>{{ $tc('label.department', 1) }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ item.address }}</td>
                <td>{{ item.city }}</td>
                <td>{{ item.cep }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.mobile }}</td>
                <td>{{ item.father }}</td>
                <td>{{ item.mother }}</td>
                <td>{{ item.partner }}</td>
                <td>{{ (new Date(item.wedding_date).toLocaleDateString('pt-BR', {timeZone: 'UTC'})) }}</td>
                <td>
                  <v-chip v-for="(department) in item.departments" small color="blue lighten-2 white--text">
                    {{ departments.find(item => item.value === department.id).text }}
                  </v-chip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>

      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }" width="100">
        <v-icon small @click="editItem(item)" class="mr-2">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)" class="mr-2">mdi-delete</v-icon>
        <v-icon small @click="expand(!isExpanded)">{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </template>

      <template v-slot:no-data>
        No results.
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="configs.page" :length="configs.pageCount"></v-pagination>
    </div>
  </div>
</template>
<script>
import {ValidationObserver} from 'vee-validate';
import AutocompleteInput from "~/views/layouts/forms/AutocompleteInput";
import ComboboxInput from "~/views/layouts/forms/ComboboxInput";
import DatePickerInput from "~/views/layouts/forms/DatePickerInput";
import FileInput from "~/views/layouts/forms/FileInput";
import SwitchInput from "~/views/layouts/forms/SwitchInput";
import TextInput from '~/views/layouts/forms/TextInput'
import {upperFirst, debounce} from 'lodash';
import {jsPDF} from 'jspdf';
import 'jspdf-autotable';
import {BLOOD_TYPES} from '~/helpers/constants';

export default {
  components: {
    AutocompleteInput,
    ComboboxInput,
    DatePickerInput,
    FileInput,
    SwitchInput,
    TextInput,
    ValidationObserver,
  },
  data: () => ({
    configs: {
      image: null,
      department: null,
      role: null,
      dialog: false,
      loading: false,
      progress: false,
      pageCount: 0,
      page: 1,
      editedIndex: -1,
      menuBirthday: null,
      search: {
        name: null,
        birthday: null,
      },
      sort: {
        by: 'id',
        desc: false,
      },
      relations: [
        {
          id: 'partner',
          label: 'partner',
          icon: 'mdi-human-male-female',
          model_id: 'partner_id',
          required: 'married',
          required_by: 'married'
        },
        {
          id: 'father',
          label: 'father',
          icon: 'mdi-human-male',
          model_id: 'father_id',
          required: false,
          required_by: false
        },
        {
          id: 'mother',
          label: 'mother',
          icon: 'mdi-human-female',
          model_id: 'mother_id',
          required: false,
          required_by: false
        },
      ],
      masks: {
        mobile: ['(##) #####-####'],
        phone: ['(##) ####-####'],
        cep: ['#####-###'],
      },
      form: {
        valid: false,
        errors: {
          image: [],
          name: null,
          sex: null,
          birthday: null,
          email: null,
          baptized: null,
          married: null,
          departments: null,
          address: null,
          cep: null,
          city: null,
          father: null,
          mobile: null,
          mother: null,
          partner: null,
          phone: null,
          wedding_date: null,
          blood_type: null,
        }
      }
    },
    editedItem: {
      image: null,
      name: null,
      sex: 0,
      birthday: null,
      email: null,
      baptized: 0,
      married: 0,
      father: null,
      mother: null,
      partner: null,
      father_id: null,
      mother_id: null,
      partner_id: null,
      blood_type: null,
      departments: []
    },
    defaultItem: {
      image: null,
      name: null,
      sex: 0,
      birthday: null,
      email: null,
      baptized: 0,
      married: 0,
      departments: [],
      // append
      address: null,
      cep: null,
      city: null,
      father: null,
      mobile: null,
      mother: null,
      partner: null,
      phone: null,
      father_id: null,
      mother_id: null,
      partner_id: null,
      wedding_date: null,
      blood_type: null,
    }
  }),

  computed: {
    formTitle() {
      return this.$t(this.editedIndex === -1 ? 'label.add' : 'label.edit') + ' ' + this.$tc(this.pageTitle, 1)
    },
    pageTitle() {
      return this.$route.meta.title
    },
    headers() {
      return [
        {value: 'id',                 text: '',                           sortable: false},
        {value: 'image',              text: this.$t('label.image'),       sortable: true},
        {value: 'name',               text: this.$t('label.name'),        sortable: true},
        {value: 'sex',                text: this.$t('label.sex'),         sortable: true},
        {value: 'blood_type',         text: this.$t('label.blood_type'),  sortable: true},
        {value: 'birthday',           text: this.$t('label.birthday'),    sortable: true},
        {value: 'email',              text: this.$t('label.email'),       sortable: true},
        {value: 'baptized',           text: this.$t('label.baptized'),    sortable: true},
        {value: 'married',            text: this.$t('label.married'),     sortable: true},
        {value: 'updated_at',         text: this.$t('label.updated_at'),  sortable: true},
        {value: 'data-table-expand',  text: this.$t('label.actions'),     sortable: false, width: '7%'},
      ];
    },
    items(){
      return this.$store.getters['members/members'] || []
    },
    totalItems(){
      return this.$store.getters['members/pagination'].total
    },
    departments(){
      return this.$store.getters['departments/list'] || []
    },
    roles(){
      return this.$store.getters['departments/roles'] || []
    },
    members(){
      return this.$store.getters['members/list'] || []
    },
    bloodTypes(){
      console.log(BLOOD_TYPES)
      return BLOOD_TYPES;
    },
    options: {
      get: function () {
        const options = this.$store.getters['members/pagination'];
        return {
          itemsPerPage: options.per_page ?? 15,
          page: options.current_page ?? 1
        };
      },
      set: function (params) {
        this.loadMembers(Object.assign({}, params, {search: this.configs.search}));
      }
    }
  },

  watch: {
    'configs.dialog'(val) {
        val || this.close()
    },
    'configs.search': {
      deep: true,
      handler: debounce(function() {
        this.options = Object.assign({}, this.options)
      }, 1000)
    },
    options: {
      handler () {},
      update () {},
      deep: true
    }
  },
  mounted() {
    this.listDepartments();
    this.listRoles();
    this.listMembers();
  },
  methods: {
    /**
     * Load the members
     * @param params
     * @returns {Promise<boolean>}
     */
    loadMembers(params = {}) {
      this.configs.loading = true
      return this.$store.dispatch('members/load', params)
          .then(() => {})
          .catch(({errors}) => errors.length && errors.map(error => this.$root.$messages.error(error)))
          .finally(() => this.configs.loading = false);
    },

    /**
     * List the departments
     * @returns {Promise<any>}
     */
    listDepartments() {
      return this.$store.dispatch('departments/list')
          .then(() => {})
          .catch(({errors}) => errors.length && errors.map(error => this.$root.$messages.error(error)));
    },

    /**
     * List the department roles
     * @returns {Promise<any>}
     */
    listRoles() {
      return this.$store.dispatch('departments/roles')
          .then(() => {})
          .catch(({errors}) => errors.length && errors.map(error => this.$root.$messages.error(error)))
    },

    /**
     * List all key/value members
     * @returns {Promise<any>}
     */
    listMembers() {
      return this.$store.dispatch('members/list')
          .then(() => {})
          .catch(({errors}) => errors.length && errors.map(error => this.$root.$messages.error(error)))
    },

    /**
     * Load the selected member to edit form
     * @param item
     */
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign(this.editedItem, item)
      this.configs.dialog = true
    },

    /**
     * Delete the member
     * @param item
     */
    deleteItem (item) {
      let self = this;

      self.$swal.queue([{
        icon: 'question',
        title: self.$t('messages.you_sure'),
        text: self.$t('messages.deleting_alert'),
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: (confirm) => {
          if (confirm) {
            self.$root.$loader.show();
            return self.$store.dispatch('members/delete', item)
                .then(response => response.meta)
                .then(data => {
                  if (data) {
                    self.$swal.insertQueueStep({
                      icon: data.status,
                      title: self.$t(`api['${data.message}']`)
                    })
                    if (data.status === 'success') {
                      self.loadMembers({page: 1})
                    }
                  }
                })
                .catch(({meta}) => {
                  self.$swal.insertQueueStep({
                    icon: 'error',
                    title: self.$t(`api['${meta.message}']`)
                  })
                })
                .finally(() => self.$root.$loader.hide())
          }
        }
      }])
    },

    /**
     * Close and clear the form
     */
    close () {
      this.configs.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.configs.image = null;
        this.configs.department = null;
        this.configs.role = null;
      })
      this.$refs.FormMember.reset()
    },

    /**
     * Validate and submit the form
     */
    save () {
      this.$refs.FormMember.validate().then(success => {
        if (success) {
          this.$root.$loader.show();
          this.clearFormErrors();
          return this.$store.dispatch(`members/${this.editedItem.id ? 'update' : 'store'}`, this.editedItem)
              .then(({meta}) => {
                  this.$root.$messages.success(meta.message);
                  this.loadMembers({page: 1});
                  this.listMembers();
                  this.close();
              })
              .catch(({errors, meta}) => {
                if (errors) {
                  if (meta) {
                    this.$root.$messages.error(meta.message);
                  }
                  Object.entries(errors).map(([label, error]) => {
                    this.configs.form.errors[label] = error.map(msg => upperFirst(this.$t(`api['${msg}']`).toLowerCase()));
                  });
                }
              })
              .finally(() => this.$root.$loader.hide());
        }
      });
    },

    /**
     * Clear the form errors
     */
    clearFormErrors()
    {
      let self = this;
      Object.keys(this.configs.form.errors).map(function(key, index) {
        self.configs.form.errors[key] = null;
      });
    },

    /**
     * Attach the department role to the member roles list
     */
    attachRole() {
      let department = this.departments.find(item => item.value === this.configs.department);
      this.editedItem.departments.push({
        id: department.value,
        role: this.configs.role,
      })
    },

    /**
     * Detach the department role from the member roles list
     * @param index
     */
    removeRole(index) {
      if (index > -1) {
        this.editedItem.departments.splice(index, 1);
      }
    },

    /**
     * Event that fires when file image input changes
     * @param image
     * @returns {Promise<void>}
     */
    async onFileChange(image) {
      let validate = await this.$refs.image.$refs.FileInput.validate();
      if (image && validate.valid) {
        this.configs.progress = true;
        return this.$store.dispatch('upload/image', image)
            .then(({meta, data}) => {
              if (meta.status === 'success') {
                this.editedItem.image = data.path;
              }
            })
            .catch((err) => {
              if (err.response && err.response.data.errors) {
                let errors = err.response.data.errors;
                for (let error in errors) {
                  if (errors.hasOwnProperty(error)) {
                    this.configs.form.errors[error] = errors[error].map(msg => upperFirst(this.$t(`api['${msg}']`).toLowerCase()));
                  }
                }
              }
            })
            .finally(() => {
              this.configs.progress = false;
            })
      }
    },

    /**
     *
     */
    exportPdf () {
      let source =  this.$refs['membersTable'],
          rows = [],
          columns = ['name', 'partner', 'birthday', 'wedding_date', 'email', 'mobile'],
          columnHeader = columns.map(item => this.$t(`label.${item}`)),
          pdfName = this.$tc(this.pageTitle, 2),
          doc = new jsPDF('l');

      console.log(source.items)
      source.items.forEach(element => {
        let temp = [];
        columns.forEach(value => {
          if(element.hasOwnProperty(value)) {
            temp.push(element[value]);
          }
        });
        rows.push(temp);
      });
      doc.autoTable(columnHeader, rows, { startY: 10 });
      doc.save(pdfName + '.pdf');
    }
  }
}
</script>